import { ModalShell, ModalFooter } from "../ui/modal";
import { useNewBuild } from "../../context/NewBuildContext";
import { UNSAFE_REASON_LABEL } from "../../../shared/update-safety";

/**
 * 배포 뒤 옛 탭의 두 얼굴 — 상태는 NewBuildContext 하나에서 온다.
 *
 *  - reloading: 화면 아래 "업데이트 중…" 알약. 안전해서 자동으로 넘기는 중이라는 표시다
 *    (아무 표시 없이 새로고침되면 고장처럼 보인다).
 *  - prompt: 한가운데 모달. 지금 새로고침하면 작업이 날아갈 수 있어 자동으로 안 넘기고 묻는다.
 *    왜 안 넘겼는지(입력 중·창 열림·저장 중…) 첫 이유를 같이 보여 준다.
 *      「지금 업데이트」 → 통째로 새로고침.
 *      「나중에 하기」(또는 Esc·닫기) → 헤더의 「업데이트」 버튼이 남고, 손이 비면 자동으로 넘어간다.
 *
 * 2026-09-05 전에는 화면 아래 작은 띠(NewBuildBanner)였는데 눈에 안 띄어 "배포했는데 반영이
 * 안 된다"는 체감이 그대로였다. 같은 날 오후 "안전하면 자동, 위험하면 묻기"로 다시 바꿨다.
 * 로그인 화면처럼 헤더가 없는 자리에도 뜬다(App 최상단에 붙어 있다).
 */
export default function NewBuildModal() {
  const { phase, reasons, reload, dismiss } = useNewBuild();

  if (phase === "reloading") {
    return (
      <div
        role="status"
        data-testid="new-build-reloading"
        className="fixed bottom-4 left-1/2 z-[100002] flex -translate-x-1/2 items-center gap-2 rounded-full border border-brand-200 bg-white px-4 py-2 text-sm text-gray-800 shadow-lg dark:border-brand-500/40 dark:bg-gray-900 dark:text-gray-100"
      >
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-brand-200 border-t-brand-500" />
        새 버전으로 업데이트 중…
      </div>
    );
  }

  const why = reasons[0] ? UNSAFE_REASON_LABEL[reasons[0]] : null;

  return (
    <ModalShell
      isOpen={phase === "prompt"}
      onClose={dismiss}
      size="sm"
      title="새 버전이 준비됐어요"
      footer={
        <ModalFooter
          onCancel={dismiss}
          cancelLabel="나중에 하기"
          confirmLabel="지금 업데이트"
          onConfirm={reload}
        />
      }
    >
      <p className="text-sm text-gray-700 dark:text-gray-300">
        화면이 새로 배포됐습니다.
        {why ? ` ${why} 자동으로 넘기지 않았어요.` : ""} 지금 업데이트하면 화면이 한 번
        새로고침되고 최신 기능이 바로 반영됩니다.
      </p>
      <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
        저장하지 않은 내용이 있으면 「나중에 하기」를 누르세요. 작업을 마치고 손이 비면 저절로
        업데이트되고, 상단의 「업데이트」 버튼으로 바로 할 수도 있습니다.
      </p>
    </ModalShell>
  );
}
